// extracted by mini-css-extract-plugin
export default {"container":"NotFound_container__dvLOl","primary":"NotFound_primary__g9rPg","btnContainer":"NotFound_btnContainer__-yB9W"};